import React from 'react'
import {
	DropHint,
	DropIconWrap,
	DropLimits,
	DropTitle,
	DropTitleButton,
	DropZoneRoot,
} from '../ItineraryImportPage.styles'
import { fileLimitsLine } from '../copy'
import { CloudUpload } from './icons'

interface DropZoneProps {
	state: 'idle' | 'dragOver'
	onBrowse: () => void
}

const DropZone: React.FC<DropZoneProps> = ({ state, onBrowse }) => {
	const isDragOver = state === 'dragOver'
	return (
		<DropZoneRoot $state={state}>
			<DropIconWrap $active={isDragOver}>
				<CloudUpload size={isDragOver ? 30 : 24} />
			</DropIconWrap>
			{isDragOver ? (
				<DropTitle $active>Drop to add</DropTitle>
			) : (
				<DropTitleButton type="button" onClick={onBrowse}>
					Add a file or screenshot
				</DropTitleButton>
			)}
			<DropHint>{fileLimitsLine()}</DropHint>
			<DropLimits>We never share your files with the rest of your crew.</DropLimits>
		</DropZoneRoot>
	)
}

export default DropZone
